import { render } from "./Restaurants.vue?vue&type=template&id=76b44d38&scoped=true"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"

import "./Restaurants.vue?vue&type=style&index=0&id=76b44d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b44d38"]])

export default __exports__